<h2 class="centered-text">{{msg}}</h2>